import React from 'react';
import cn from 'classnames';
import ModalReport from './modal';
import { IconButton } from 'src/components';
import { useModal } from 'src/hooks/useModal';
import styles from './styles.module.scss';
import Button from 'src/components/button';

interface IProps {
    icon?: string;
    textBtn?: string;
    onSubmit: (id: any) => void;
    okText?: string;
    cancelText?: string;
    classNameBtn?: string;
    item: any;
}

const ReportButton = ({ onSubmit, item }: IProps) => {
    const { Modal, show, hide } = useModal();

    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        show();
    };

    return (
        <>
            <Button
                title="Báo lôi"
                className={cn(
                    'btn-report-ad',
                    'flex items-center justify-center',
                    'absolute right-0 bottom-0',
                    'w-[24px] h-[24px]',
                    'bg-[#f8f9fa]',
                    'text-[1.6rem] leading-[28px]',
                    'text-[1.6rem] text-[#adb5bd]',
                    "before:content-['×']"
                )}
                onClick={handleClick}
            >
                <></>
            </Button>
            <Modal>
                <ModalReport hide={hide} onSubmit={onSubmit} item={item} />
            </Modal>
        </>
    );
};

export default ReportButton;
